<template>
  <b-alert variant="warning" show class="section-error">
    <div class="section-error__row">
      <span>
        <feather-icon icon="AlertTriangleIcon" size="15" class="mr-50" />
        {{ message || $t('influencer_panel.section_error') }}
      </span>
      <b-button variant="flat-warning" size="sm" @click="$emit('retry')">
        {{ $t('influencer_panel.retry') }}
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'

/**
 * Falha de uma secao, dentro da propria secao.
 *
 * Antes as telas de campanhas e carteira faziam `.catch(() => {})`: a chamada falhava e o
 * usuario via uma lista vazia, indistinguivel de "voce nao tem nada". Aqui o erro fica
 * onde o dado estaria, e as outras secoes continuam de pe.
 */
export default {
  name: 'SectionError',
  components: { BAlert, BButton },
  props: {
    message: { type: String, default: '' },
  },
}
</script>

<style scoped>
.section-error {
  padding: 0.75rem 1rem;
  margin: 0;
}

.section-error__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
</style>
